module.exports = __webpack_public_path__ + "img/pending_zone_selected.035b8cd4.svg";